import type { Event } from '@sentry/react';

type WithData = { data?: Record<string, unknown> };

const URL_KEYS = ['url', 'from', 'to', 'http.url', 'url.full'];
const URL_SPAN_OPS = /^(resource|navigation)\./;

const stripQuery = (url: string) => url.split(/[?#]/, 1)[0];

export const stripDataQuery = <T extends WithData>(item: T) => {
  const { data } = item;
  if (!data) return item;
  for (const key of URL_KEYS) {
    const value = data[key];
    if (typeof value === 'string') data[key] = stripQuery(value);
  }
  delete data['http.query'];
  delete data['http.fragment'];
  return item;
};

export const stripEventQuery = <T extends Event & { urls?: string[] }>(event: T) => {
  const { request } = event;
  if (event.urls) event.urls = event.urls.map(stripQuery);
  if (!request) return event;
  if (request.url) request.url = stripQuery(request.url);
  if (request.headers?.Referer) request.headers.Referer = stripQuery(request.headers.Referer);
  delete request.query_string;
  return event;
};

export const stripRecordingEventQuery = <T extends { data?: unknown }>(event: T) => {
  const data = event.data as { href?: unknown; payload?: { op?: unknown; description?: unknown } } | undefined;
  if (typeof data?.href === 'string') data.href = stripQuery(data.href);
  const payload = data?.payload;
  if (
    payload &&
    typeof payload.op === 'string' &&
    URL_SPAN_OPS.test(payload.op) &&
    typeof payload.description === 'string'
  ) {
    payload.description = stripQuery(payload.description);
  }
  return event;
};
